import { SpikeGenImagesProps } from "../../interfaces/core";
import randomItem from "../randomItem";
import { increase_brightness } from "./colors";
import angles from "./pies";
interface SpikePieProps {
  //   ctx: CanvasRenderingContext2D;
  //   canvas: HTMLCanvasElement;
  colors: any[];
  format: {
    baseWdith: number;
    baseHeight: number;
    width: number;
    height: number;
    smoothing: boolean;
    gradient: boolean;
    multiColor: boolean;
    colorGradient: boolean;
    scale: number;
    numberOfImages: number;
  };
  tiles: {
    x: number;
    y: number;
  };
}

const resizeImage = async (imgData, w, h) => {
  let img = new Image();
  let result = new Image();
  img.src = imgData;
  await img.decode();
  let canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  canvas.getContext("2d").drawImage(img, 0, 0, w, h);
  result.src = canvas.toDataURL("image/jpeg", 0.85);
  await result.decode();
  return result;
};

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const isColorTooBright = (color: string) => {
  const tooBrightColors = ["yellow", "cyan", "lime", "gray"];
  return tooBrightColors.includes(color.toLowerCase());
};

const startCreating = async ({ colors, format, tiles }: SpikePieProps) => {
  const results: SpikeGenImagesProps[] = [];
  const canvas = document.createElement("canvas");
  canvas.width = format.width;
  canvas.height = format.height;
  const ctx = canvas.getContext("2d")!;
  ctx.imageSmoothingEnabled = format.smoothing;
  let layerConfigIndex = 0;

  const layerConfigurations = [
    {
      growEditionSizeFrom: 1,
      growEditionSizeTo: format.numberOfImages,
    },
  ];
  let editionCount = layerConfigurations[layerConfigIndex].growEditionSizeFrom;
  const abstractedIndexes = [];

  for (
    let i = layerConfigurations[layerConfigIndex].growEditionSizeFrom;
    i <= layerConfigurations[layerConfigIndex].growEditionSizeTo;
    i++
  ) {
    abstractedIndexes.push(i);
  }
  /* debugLogs
    ? console.log("Editions left to create: ", abstractedIndexes)
    : null; */
  while (
    editionCount <= layerConfigurations[layerConfigIndex].growEditionSizeTo
  ) {
    const attributesList: { type: string; name: string }[] = [],
      statsList: { name: string; from: number; to: number }[] = [];
    const id = new Date().valueOf();
    let colorPalette = randomItem(colors);
    // console.log(randomItem(emoji), ` Chose color:`, colorPalette.name);
    attributesList.push({
      type: "COLOR",
      name: format.multiColor
        ? "Multi-color"
        : capitalizeFirstLetter(colorPalette.name),
    });

    const addLevels = (_key: string, value: string, to: number) => {
      if (statsList.findIndex((list) => list.name === value) === -1) {
        const level = {
          name: value,
          from: 1,
          to,
        };
        statsList.push(level);
      } else {
        statsList.find((list) => list.name === value)!.from++;
      }
    };
    attributesList.push({
      type: "COLOR TYPE",
      name: format.gradient ? "Gradient" : "solid",
    });
    attributesList.push({
      type: "ASPECT RATIO",
      name: `${tiles.x} x ${tiles.y}`,
    });
    // let results = constructLayerToDna(newDna, layers);
    // loadedElements.push(loadLayerImg());
    ctx.save();
    // Use the identity matrix while clearing the canvas
    ctx.setTransform(format.scale, 0, 0, format.scale, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    /* Loop using .FG and .BG from angles */
    const colorTo = 90 * tiles.x * tiles.y; // Amount of colors generated
    /* Perform Y tiles first, then perform X tiles */
    for (let tileX = 0; tileX < tiles.x; tileX++) {
      // console.log(randomItem(emoji), ` Generating Tile X:`, tileX);
      const sizeX = format.width / tiles.x,
        sizeY = format.height / tiles.y;
      const tx = sizeX * tileX;
      for (let tileY = 0; tileY < tiles.y; tileY++) {
        const randomAngleIndex = randomItem([...Array(angles.length).keys()]);
        const randomAngle = angles[randomAngleIndex];
        const ty = sizeY * tileY;
        // console.log(randomItem(emoji), ` Generating Tile Y:`, tileY + 1);
        // console.log(randomItem(emoji), ` Move tile to X:`, tx, `\n Move tile to Y:`, ty);
        for (const angleKey in randomAngle) {
          if (randomAngle.hasOwnProperty(angleKey)) {
            for (
              let i = 0;
              i < randomAngle[angleKey as "BG" | "FG"].length;
              i++
            ) {
              colorPalette = format.multiColor
                ? randomItem(colors)
                : colorPalette;
              let fg_path = randomAngle[angleKey as "BG" | "FG"][i];
              let fg_p = new Path2D(fg_path);
              const colorIndexes = [
                ...Array(colorPalette[angleKey].length).keys(),
              ]; // e.g. [1,2,3,4,5,6]
              const fillColorIndexfunc = randomItem(colorIndexes); // e.g. 1
              const fillColorIndex =
                fillColorIndexfunc < 1 ? 1 : fillColorIndexfunc; // e.g. 1
              const fillColor = colorPalette[angleKey][fillColorIndex]; // Generate random color and add it to metalist
              // If gradient enabled, generate and add two colors
              if (format.gradient) {
                // console.log({ fillColorIndex });
                const gradientAngles = {
                  BG: [
                    {
                      // Top left
                      x0: 0,
                      y0: 0,
                      r0: 0,
                      x1: 0,
                      y1: 0,
                      r1: sizeY / format.scale,
                    },
                    {
                      // Top right
                      x0: sizeX / format.scale,
                      y0: 0,
                      r0: 0,
                      x1: sizeX / format.scale,
                      y1: 0,
                      r1: sizeY / format.scale,
                    },
                    {
                      // Bottom left
                      x0: 0,
                      y0: sizeY / format.scale,
                      r0: 0,
                      x1: 0,
                      y1: sizeY / format.scale,
                      r1: sizeY / format.scale,
                    },
                    {
                      // Bottom right
                      x0: sizeX / format.scale,
                      y0: sizeX / format.scale,
                      r0: 0,
                      x1: sizeY / format.scale,
                      y1: sizeY / format.scale,
                      r1: sizeY / format.scale,
                    },
                  ],
                  FG: [
                    {
                      // Bottom right
                      x0: sizeX / format.scale,
                      y0: sizeX / format.scale,
                      r0: 0,
                      x1: sizeY / format.scale,
                      y1: sizeY / format.scale,
                      r1: sizeY / format.scale,
                    },
                    {
                      // Bottom left
                      x0: 0,
                      y0: sizeY / format.scale,
                      r0: 0,
                      x1: 0,
                      y1: sizeY / format.scale,
                      r1: sizeY / format.scale,
                    },
                    {
                      // Top right
                      x0: sizeX / format.scale,
                      y0: 0,
                      r0: 0,
                      x1: sizeX / format.scale,
                      y1: 0,
                      r1: sizeY / format.scale,
                    },
                    {
                      // Top left
                      x0: 0,
                      y0: 0,
                      r0: 0,
                      x1: 0,
                      y1: 0,
                      r1: sizeY / format.scale,
                    },
                  ],
                };
                const lighterColorIndex = randomItem([
                  ...Array(fillColorIndex < 1 ? 0 : fillColorIndex).keys(),
                ]);
                const colorStopOrgin = Math.random();
                const colorStopEnd = Math.random();
                const gradientThreashold = {
                  FG: {
                    lighter: 0.35,
                    darker: 0.35,
                    brightness: colorStopOrgin > 0.35 ? colorStopOrgin : 0.35,
                  },
                  BG: {
                    lighter: 0.1,
                    darker: 0.8,
                    brightness: colorStopOrgin < 0.55 ? colorStopOrgin : 0.55,
                  },
                };
                // console.log({ gradient: gradientAngles[randomAngleIndex], key: randomAngleIndex });
                const { x0, y0, r0, x1, y1, r1 } =
                  gradientAngles[angleKey as "BG" | "FG"][randomAngleIndex];
                const gradient = ctx.createRadialGradient(
                  x0,
                  y0,
                  r0,
                  x1,
                  y1,
                  r1
                );
                const darkerColorGradient =
                  format.multiColor && format.colorGradient
                    ? randomItem(colors)
                    : colorPalette;
                const lighterColorGradient =
                  format.multiColor && format.colorGradient
                    ? randomItem(colors)
                    : colorPalette;
                let lighterColor =
                  lighterColorGradient[angleKey][lighterColorIndex];
                lighterColor = isColorTooBright(colorPalette.name)
                  ? lighterColor
                  : increase_brightness(lighterColor, colorStopOrgin * 30);
                const darkerColor =
                  darkerColorGradient[angleKey][fillColorIndex];
                // console.log(darkerColor, lighterColor);
                gradient.addColorStop(
                  colorStopOrgin *
                    gradientThreashold[angleKey as "BG" | "FG"].lighter,
                  lighterColor
                );
                gradient.addColorStop(
                  1 -
                    colorStopEnd *
                      gradientThreashold[angleKey as "BG" | "FG"].darker,
                  darkerColor
                );
                const _levelMeta =
                  darkerColor === lighterColor
                    ? darkerColor
                    : `${darkerColor} - ${lighterColor}`;
                addLevels(`color`, _levelMeta, colorTo);
                ctx.fillStyle = gradient;
                ctx.fill(fg_p);
              } else {
                addLevels(`color`, fillColor, colorTo);
                ctx.fillStyle = fillColor;
                ctx.fill(fg_p);
              }
              // console.log(`updated color with ${fillColor}`);
            }
          }
        }
        ctx.translate(0, sizeY / format.scale);
      }
      ctx.translate(sizeX / format.scale, (-sizeY * tiles.y) / format.scale);
      // ctx.translate(sizeX, sizeY);
    }
    const img = new Image();
    const data = canvas.toDataURL("image/jpeg", 0.85);
    img.src = data;
    await img.decode();
    const img2 = (await resizeImage(
      data,
      512,
      (512 * tiles.y) / tiles.x
    )) as HTMLImageElement;
    const progressValue =
      layerConfigurations[layerConfigIndex].growEditionSizeTo -
      layerConfigurations[layerConfigIndex].growEditionSizeFrom +
      1 -
      abstractedIndexes.length;

    // await saveImage(abstractedIndexes[0]);
    results.push({
      full: img.src,
      preview: img2.src,
      id,
      statsList,
      attributesList,
    });

    ctx.restore();
    // console.log(`✅ Created edition: ${abstractedIndexes[0]} \n`);
    // dnaList.add(filterDNAOptions(newDna));
    // console.log({ editionCount });
    editionCount++;
    abstractedIndexes.shift();
  }

  // const generatedColors: { name: any; count: number }[] = [];

  // const countColors = (value: any) => {
  //   if (generatedColors.findIndex((list) => list.name === value) === -1) {
  //     const level = {
  //       name: value,
  //       count: 1,
  //     };
  //     generatedColors.push(level);
  //   } else {
  //     generatedColors.find((list) => list.name === value)!.count++;
  //   }
  // };

  // const rawColors = statsList.map((c) => c.name);

  // for (let i = 0; i < rawColors.length; i++) {
  //   countColors(rawColors[i]);
  // }
  // // console.log({ rawColors });
  // const colorPercent = (num: number) =>
  //   `${Math.round((num / rawColors.length + Number.EPSILON) * 100)}%`;
  // console.log(`\n------- Done! ------ \n`);
  // console.log(`\r\r 🎨 Colors Generated: `);
  // generatedColors.map((c) =>
  //   console.log(
  //     `\r\r ${c.name.toUpperCase()}: `,
  //     c.count,
  //     " | ",
  //     colorPercent(c.count)
  //   )
  // );
  // console.log(`\n`);
  return results;
};

export default startCreating;
